/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ScreensPageType from '@jira/admin-pages__screens-page/src/ScreensPage.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyScreensPage: LazyComponent<typeof ScreensPageType> = lazyForPaint<
	typeof ScreensPageType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-jira-admin-pages-screens-page", jiraSpaEntry: "async-jira-admin-pages-screens-page" */ '@jira/admin-pages__screens-page/src/ScreensPage.tsx'
		),
	),
);

const AsyncScreensPage = (): React.JSX.Element => (
	<LazyPage Page={LazyScreensPage} pageId="jira-admin-pages-screens-page" shouldShowSpinner />
);

export default AsyncScreensPage;
